<!--  -->
<template>
      <div class="no-goods">
        <img class="no-goods-img" :src="require('@/assets/img/shopping-cart.png')" alt="">
        <p>{{msg}}</p>
        <p>快去采购吧</p>
        <router-link class="no-goods-btn" tag="div" to="/home" >去逛逛</router-link>
      </div>
</template>

<script>
export default {
  components: {},

  props: {
    msg: {
      type: String,
      default: '亲，购物车空空如也~'
    }
  },

  data () {
    return {
    }
  },

  computed: {},

  watch: {},

  created () {},

  methods: {}
}

</script>
<style lang='scss' scoped>
/**购物车无商品 */
.no-goods{
  text-align: center;
  margin-top: 40px;
  &-img{
    width: 161px;
    height: 131px;
    margin-bottom: 25px;
  }
  p{
    margin-bottom: 10px;
  }
  &-btn{
    width: 150px;
    height: 35px;
    margin: auto;
    border: 1px solid var(--APP_theme_color);
    border-radius: 20px;
    background-color: var(--APP_theme_color);
    color: #ffffff;
    font-size: 14px;
    @include center()
  }
}
</style>
